import { Link } from "react-router-dom";

export function HomePage() {
  return (
    <div className="flex flex-col">

      {/* Two-panel hero */}
      <section className="flex flex-col md:flex-row min-h-[calc(100vh-4rem)]">

        {/* Left — Platform */}
        <div className="flex-1 flex flex-col justify-center bg-gradient-to-br from-zinc-200 to-zinc-300 px-10 py-20 md:px-16 lg:px-24">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary mb-4">
            Platform
          </span>
          <h1 className="text-4xl lg:text-5xl font-bold tracking-tight text-foreground leading-[1.1] mb-5">
            Modern Technology<br />for Modern Campaigns
          </h1>
          <p className="text-base text-muted-foreground leading-relaxed max-w-sm mb-8">
            Voter data, walkbooks, and real-time field sync in one platform.
            Built for the teams that know doors win races.
          </p>
          <div className="flex flex-col sm:flex-row gap-5">
            <Link
              to="/request-access"
              className="text-sm font-medium text-foreground underline underline-offset-4 hover:text-primary transition-colors"
            >
              Request early access
            </Link>
            <Link
              to="/features"
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              See how it works →
            </Link>
          </div>

          {/* Mini stats */}
          <div className="mt-14 flex gap-10">
            {[
              { value: "100%", label: "Offline capable" },
              { value: "Real-time", label: "Sync & reporting" },
              { value: "Any CSV", label: "Import source" },
            ].map((s) => (
              <div key={s.label}>
                <p className="text-lg font-bold text-primary">{s.value}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="hidden md:block w-px bg-border/60" />

        {/* Right — Strategy */}
        <div className="flex-1 flex flex-col justify-center bg-zinc-900 px-10 py-20 md:px-16 lg:px-24">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary mb-4">
            Strategy
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold tracking-tight text-white leading-[1.1] mb-5">
            Field strategy<br />that wins races
          </h2>
          <p className="text-base text-zinc-400 leading-relaxed max-w-sm mb-8">
            Voter targeting, field management, and full-cycle campaign strategy from
            practitioners who have run programs at every level of the ballot.
          </p>
          <div className="flex flex-col sm:flex-row gap-5">
            <Link
              to="/strategy"
              className="text-sm font-medium text-white underline underline-offset-4 hover:text-primary transition-colors"
            >
              Work with us
            </Link>
            <Link
              to="/strategy#services"
              className="text-sm font-medium text-zinc-400 hover:text-white transition-colors"
            >
              Our services →
            </Link>
          </div>

          {/* Mini stats */}
          <div className="mt-14 flex gap-10">
            {[
              { value: "Targeting", label: "Voter & district" },
              { value: "Field Ops", label: "End-to-end management" },
              { value: "Strategy", label: "Full-cycle" },
            ].map((s) => (
              <div key={s.label}>
                <p className="text-lg font-bold text-primary">{s.value}</p>
                <p className="text-xs text-zinc-500 mt-0.5">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

      </section>

      {/* Platform features strip */}
      <section className="bg-white border-t border-border/60">
        <div className="max-w-6xl mx-auto px-6 py-20">
          <div className="text-center mb-14">
            <span className="text-xs font-semibold uppercase tracking-widest text-primary">Platform</span>
            <h2 className="text-3xl font-bold tracking-tight mt-2">Everything your field team needs</h2>
            <p className="text-muted-foreground mt-3 max-w-xl mx-auto">
              Built from the ground up for political campaigns that take door-knocking seriously.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                title: "Voter data, your way",
                body: "Import CSVs from VAN or any source. Our column mapper handles the mess so your team sees clean, structured data.",
              },
              {
                title: "Smart walkbooks",
                body: "Generate optimized walking routes and scripts in minutes. Assign them to volunteers and track completion in real time.",
              },
              {
                title: "Offline-first mobile",
                body: "Volunteers knock doors even with no signal. Interactions sync automatically when they're back on Wi-Fi.",
              },
            ].map((f) => (
              <div key={f.title} className="rounded-xl border border-border/60 p-6">
                <div className="w-7 h-7 rounded-md bg-primary/10 flex items-center justify-center mb-4">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary" />
                </div>
                <h3 className="font-semibold text-foreground mb-2">{f.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{f.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-primary">
        <div className="max-w-6xl mx-auto px-6 py-20 text-center">
          <h2 className="text-3xl font-bold text-white tracking-tight mb-4">
            Ready to hit the doors?
          </h2>
          <p className="text-primary-foreground/75 mb-8 max-w-md mx-auto">
            Join the waitlist and get early access when we launch.
          </p>
          <Link
            to="/request-access"
            className="inline-block text-sm font-semibold text-primary bg-white rounded-md px-6 py-3 hover:bg-white/90 transition-colors"
          >
            Request access
          </Link>
        </div>
      </section>

    </div>
  );
}
